import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  DeletePurchaseRequestCronjobDocument,
  DeletePurchaseRequestCronjobMutation,
} from "./generated-graphql/graphql";

export const bulkDeleteAction: BulkAction = {
  location: "purchase-request-cronjob-table",
  label: "Delete Selected Cron Jobs",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) =>
    userPermissions.includes("DeletePurchaseRequestCronJob"),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: "Delete Selected Cron Jobs",
        body: `Are you sure you want to delete ${selection.length} purchase request cron jobs?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeletePurchaseRequestCronjobMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeletePurchaseRequestCronjobDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            let deletedCount = 0;
            res.forEach((r) => {
              const { deletePurchaseRequestCronjob } = r;
              if (deletePurchaseRequestCronjob.result === "DELETED") {
                deletedCount++;
              }
              if (deletedCount > 0) {
                notificationService.success(
                  `Deleted ${deletedCount} cron jobs sucessfully`
                );
              }
            });
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};
